import { auth } from '@/boots/firebase';

const onceAuthResolved = (store, fn) => {
  if (store.state.auth.resolved) return fn();
  const unwatch = store.watch(
    (state) => state.auth.resolved,
    () => {
      unwatch();
      fn();
    },
  );
  return null;
};

export default async ({ router, store }) => {
  router.beforeEach((to) => {
    store.dispatch('auth/request');

    return new Promise((resolve) => {
      onceAuthResolved(store, async () => {
        try {
          const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
          const { currentUser } = auth;

          if (currentUser) {
            const { claims } = await currentUser.getIdTokenResult();

            if (claims.superAdmin || claims.eyeStaff) {
              if (['/admin/devices'].includes(to.path)) {
                return resolve({ path: '/admin/organisations' });
              }
            }

            if (claims.orgAdmin) {
              if (['/admin/organisations'].includes(to.path)) {
                return resolve({ path: '/admin/users' });
              }
            }

            if (!claims.superAdmin && !claims.eyeStaff && !claims.orgAdmin) {
              if (['/admin/organisations', '/admin/users'].includes(to.path)) {
                return resolve({ path: '/admin/devices' });
              }
            }
          }

          if (requiresAuth && !currentUser) {
            return resolve({ path: '/login' });
          } if (!requiresAuth && currentUser) {
            return resolve({ path: '/' });
          }
          return resolve(true);
        } catch (error) {
          console.error('Auth guard error:', error);
          return resolve({ path: '/login' });
        }
      });
    });
  });
};
